module.exports = __webpack_public_path__ + "static/media/optum_graphdb.05ca3760.png";